import { render, staticRenderFns } from "./ForumList.vue?vue&type=template&id=4fa729f6&scoped=true&"
import script from "./ForumList.vue?vue&type=script&lang=js&"
export * from "./ForumList.vue?vue&type=script&lang=js&"
import style0 from "./ForumList.vue?vue&type=style&index=0&id=4fa729f6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa729f6",
  null
  
)

export default component.exports